import { useEffect, useState } from "react";
import { estadoNotion } from "./estadoNotion";

// «Notion al día, hace X»: una linea discreta bajo la cabecera de Tareas. Estado en texto y simbolo (el color
// nunca es lo unico). Sin Notion conectado no pinta nada. El estado lo da el servidor (datos.notion); aqui solo se
// dice, se ofrece sincronizar a mano y, con la sesion caducada, reconectar.
export default function NotionAlDia({ notion, onSincronizar, onReconectar }) {
  const [ahora, setAhora] = useState(Date.now());
  const [enCurso, setEnCurso] = useState(false);
  // El «hace X» sigue siendo verdad aunque la pantalla se quede abierta
  useEffect(() => { const id = setInterval(() => setAhora(Date.now()), 60000); return () => clearInterval(id); }, []);

  const est = estadoNotion(notion, ahora);
  if (!est) return null;

  const sincronizar = async () => {
    setEnCurso(true);
    try { await onSincronizar(); } finally { setEnCurso(false); }
  };
  const trabajando = est.tipo === "sync" || enCurso;

  return (
    <div className={"mt-notion " + est.tipo} role="status" aria-live="polite">
      <span className="mt-notion-s" aria-hidden="true">{est.simbolo}</span>
      <span className="mt-notion-t">{enCurso && est.tipo !== "sync" ? "Sincronizando Notion…" : est.texto}</span>
      {est.detalle && !enCurso && <span className="mt-notion-d">{est.detalle}</span>}
      {est.reconectar && onReconectar && (
        <button type="button" className="mt-notion-b btn" onClick={onReconectar}>Reconectar Notion</button>
      )}
      {est.sincronizar && onSincronizar && (
        <button type="button" className="mt-notion-b btn" disabled={trabajando} onClick={sincronizar}>Sincronizar</button>
      )}
    </div>
  );
}
